// because we mix namespaces will ES6 modules, certain modules need to be pre-loaded

// shared
import "js/preload";

// core
import "js/core/preload";

// elements
import "js/elements/preload";

// player
import "js/player/player";
